import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import styles from "./index.module.scss";

const Carousel = ({ data = [] }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const scrollTo = useCallback(
    (index) => emblaApi && emblaApi.scrollTo(index),
    [emblaApi]
  );
  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi, setSelectedIndex]);
  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);
  return (
    <div className={styles.embla} ref={emblaRef}>
      <div className={styles.container}>
        {data.map((el, index) => (
          <div className={styles.slide} key={index}>
            {el}
          </div>
        ))}
      </div>
      <div className={styles.dots}>
        {data.map((el, index) => (
          <span
            className={`${styles.dot} ${
              index === selectedIndex && styles.active
            }`}
            onClick={() => scrollTo(index)}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
